import React from "react";
import {
    Paper,
    Typography,
    IconButton,
    Fade,
    Portal,
    Box,
} from "@mui/material";
import { X } from "lucide-react";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const DescriptionDialog = ({ open, onClose, children, anchorEl }) => {
    const { getFontSize } = useResponsiveStyles();
    if (!anchorEl) return null;

    const rect = anchorEl.getBoundingClientRect();

    return (
        <Portal>
            <Fade in={open}>
                <Paper
                    elevation={4}
                    sx={{
                        position: "fixed",
                        top: rect.top - 10,
                        left: rect.width / 2 + 400,
                        maxHeight: "200px",
                        zIndex: 1300,
                        p: 2,
                        transition: "opacity 0.2s ease-in-out",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                        borderRadius: "8px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                color: "#C43A29",
                                ...getFontSize("sub-heading"),
                            }}
                        >
                            Description
                        </Typography>

                        <IconButton
                            onClick={onClose}
                            size="small"
                            sx={{
                                position: "absolute",
                                right: 8,
                                color: "#C43A29",
                                top: 8,
                                "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                },
                            }}
                        >
                            <X size={16} />
                        </IconButton>
                    </Box>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            pr: 4,
                            // maxHeight: "180px",
                            maxWidth: "600px",
                            overflowY: "auto",
                            "&::-webkit-scrollbar": {
                                width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "4px",
                            },
                        }}
                    >
                        {children}
                    </Typography>
                </Paper>
            </Fade>
        </Portal>
    );
};
